var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{attrs:{"id":"app"}},[(_vm.selectedRiverName)?_c('h2',{staticClass:"my-10 mx-5 d-flex justify-center color"},[_vm._v(_vm._s(_vm.selectedRiverName))]):_c('h2',{staticClass:"my-10 mx-5 d-flex justify-center color"},[_vm._v(" Choose a river from the list to see their registered work ")]),_c('RiverPolygonList',{staticClass:"pa-6"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }